export default __webpack_public_path__ + "static/media/junit.904b6df1.svg";